import { EVENT_LOG_ENDPOINTS } from './event-log.api-constants';
import { CreateEventLogRequestDto } from './event-log.api-types';

/**
 * Sends an event-log entry with `keepalive: true` (SWRN-1639, A1) so the
 * browser completes the request even if the page is closing or the tab is
 * being backgrounded — a plain XHR/axios call is aborted on tab close, which
 * is exactly when terminal events (e.g. `order completed`) were being lost.
 *
 * Native `fetch` is used instead of `apiClient` because axios's XHR adapter
 * does not support `keepalive`. The endpoint is same-origin, so no CORS
 * preflight applies. Payload is well under the 64KB keepalive limit.
 */
export async function createEventLog(
    dto: CreateEventLogRequestDto,
): Promise<void> {
    await fetch(EVENT_LOG_ENDPOINTS.CREATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dto),
        keepalive: true,
    });
}
